import React, { useState } from 'react';
import './ActiveMatchBanner.css';

function mapImgUrl(tag) {
  if (!tag) return null;
  const ext = tag === 'de_train' ? 'png' : 'jpg';
  return `/stats/images/maps/${tag}.${ext}`;
}

/**
 * Persistent banner shown while the user has an active match (CREATED →
 * STARTED → LIVE). Disappears automatically when the match finishes.
 *
 * Cannot be fully dismissed — only minimized to a small floating pill — so
 * the user never loses access to the lobby/veto page or the connect string.
 *
 * @param {Object} props
 * @param {Object} props.matchData - Active match data object.
 */
export default function ActiveMatchBanner({ matchData }) {
  const [minimized, setMinimized] = useState(false);
  const [copied, setCopied] = useState(false);

  if (!matchData) return null;

  const {
    team1_name,
    team2_name,
    map_name,
    map_tag,
    status,
    connect_command,
    steam_connect_link,
  } = matchData;

  const statusText =
    status === 'LIVE' ? 'LIVE' : status === 'STARTED' ? 'Redo' : 'Skapas';

  const isReady = status === 'STARTED' || status === 'LIVE';
  const hasConnect = isReady && (steam_connect_link || connect_command);

  const handleCopy = () => {
    if (!connect_command) return;
    navigator.clipboard.writeText(connect_command).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  // When minimized the banner unmounts entirely — the navbar entry next to
  // /live remains as the persistent indicator + gateway back to the lobby.
  // The banner re-surfaces automatically on the next status change because
  // App.js keys it on `${match_id}-${status}`.
  if (minimized) return null;

  return (
    <div className="active-match-overlay">
      <div className="active-match-banner">
        {map_tag && (
          <div
            className="active-match-map-bg"
            style={{ backgroundImage: `url(${mapImgUrl(map_tag)})` }}
          />
        )}
        <div className="active-match-content">
          <div className="active-match-info">
            <span className={`active-match-status ${status.toLowerCase()}`}>
              {statusText}
            </span>
            <span className="active-match-teams">
              {team1_name} vs {team2_name}
            </span>
            {map_name && <span className="active-match-map">{map_name}</span>}
          </div>
          <div className="active-match-actions">
            {hasConnect && (
              <>
                {steam_connect_link && (
                  <a
                    className="active-match-btn connect"
                    href={steam_connect_link}
                  >
                    Anslut
                  </a>
                )}
                {connect_command && (
                  <button
                    className="active-match-btn copy"
                    onClick={handleCopy}
                    title={connect_command}
                  >
                    {copied ? 'Kopierat!' : 'Kopiera'}
                  </button>
                )}
              </>
            )}
            <button
              className="active-match-btn dismiss"
              onClick={() => setMinimized(true)}
              title="Minimera"
            >
              –
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
